import React from "react";
import PropTypes from "prop-types";
import {Button} from "reactstrap";
import "./CommonHeader.scss";

/** This component will render a header button */

const CommonHeader = (props) => {
  const {content = "", handleAddClick = () => {}, testID = "header_button"} = props;

  return (
    <div className="common-header-container">
      {content && (
        <Button
          data-cy={testID}
          className="btn_common roboto-bold"
          onClick={handleAddClick}
          style={{zIndex: "10"}}
        >
          {content.toUpperCase()}
        </Button>
      )}
    </div>
  );
};

CommonHeader.propTypes = {
  /** Text to be displayed on header button */
  content: PropTypes.string.isRequired,
  /** Callback function which will be executed when clicked on header button */
  handleAddClick: PropTypes.func,
  /** testID which will be passed ad data-cy attribute on header button */
  testID: PropTypes.string,
};

export default CommonHeader;
